module.exports = __webpack_public_path__ + "img/2-7847.71bde73b.png";